import { Link } from "react-router-dom";
import { To } from "history";
import { useSelector } from "react-redux";
import { selectUiBranding } from "store/reducers/branding";

// material-ui
import { ButtonBase } from "@mui/material";
import { SxProps } from "@mui/system";

// project import
import Logo from "./LogoMain";
import LogoIcon from "./LogoIcon";
import config from "config/config";

// ==============================|| MAIN LOGO ||============================== //

interface Props {
  reverse?: boolean;
  isIcon?: boolean;
  sx?: SxProps;
  to?: To;
}

const LogoSection = ({ reverse, isIcon, sx, to }: Props) => {
  const ui = useSelector(selectUiBranding);

  const logoIcon = ui?.assets?.logo?.url || undefined; // Use the icon URL from branding if available, otherwise fallback to default
  const logoMain = ui?.assets?.printHeaderLogo?.url || undefined; // Use the main logo URL from branding if available, otherwise fallback to default
  
  return (
    <ButtonBase
      disableRipple
      component={Link}
      to={!to ? config.config.defaultPath : to}
      sx={sx}
    >
      {isIcon ? (
        <LogoIcon src={logoIcon} />
      ) : (
        <Logo src={logoMain} reverse={reverse} />
      )}
    </ButtonBase>
  );
};

export default LogoSection;
